let slidesPerPage = 6;

// We're on a product page
if (Array.prototype.some.call(document.body.classList, function (className) {
  return className.indexOf('template-product') !== -1;
})) {
  slidesPerPage = 5;
}

var product_list_swiper = new Swiper(".product-list-swiper", {
  loop: false,
  spaceBetween: 10,
  slidesPerView: slidesPerPage,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      loop: true,
      initialSlide: 2,
    },
    480: {
      slidesPerView: 1,
      loop: true,
      initialSlide: 2,
    },
    768: {
      slidesPerView: 3,
      loop: false
    },
    1024: {
      slidesPerView: slidesPerPage,
      loop: false
    },
  }
});